export default class MetodiDiPagamento{
    CodicePagamento;
    Descrizione;
    constructor(){}
}